var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"v-icon__svg",attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5,17.59,15.59,7H11.51V5H19v7.49H17V8.41L6.41,19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }